export const countryCodes = {
    US: 'US',
    Canada: 'CA',
    Australia: 'AU',
    'New Zealand': 'NZ',
    Other: 'Other'
};

export const stateLabel: Record<CountryCode, string> = {
    US: 'State',
    Canada: 'Province',
    Australia: 'State',
    'New Zealand': 'Region',
    Other: 'Province'
};

export const zipLabel: Record<CountryCode, string> = {
    US: 'Zip',
    Canada: 'Postal Code',
    Australia: 'Postal Code',
    'New Zealand': 'Postal Code',
    Other: 'Postal Code'
};

export type CountryCode = keyof typeof countryCodes;

export const countryStates: Record<CountryCode, { label: string; value: string }[]> = {
    Canada: [
        { label: 'Alberta', value: 'AB' },
        { label: 'British Columbia', value: 'BC' },
        { label: 'Manitoba', value: 'MB' },
        { label: 'New Brunswick', value: 'NB' },
        { label: 'Newfoundland and Labrador', value: 'NL' },
        { label: 'Nova Scotia', value: 'NS' },
        { label: 'Ontario', value: 'ON' },
        { label: 'Prince Edward Island', value: 'PE' },
        { label: 'Quebec', value: 'QC' },
        { label: 'Saskatchewan', value: 'SK' },
        { label: 'Northwest Territories', value: 'NT' },
        { label: 'Nunavut', value: 'NU' },
        { label: 'Yukon', value: 'YT' }
    ],
    Australia: [
        { label: 'New South Wales', value: 'NSW' },
        { label: 'Victoria', value: 'VIC' },
        { label: 'Queensland', value: 'QLD' },
        { label: 'Western Australia', value: 'WA' },
        { label: 'South Australia', value: 'SA' },
        { label: 'Tasmania', value: 'TAS' },
        { label: 'Australian Capital Territory', value: 'ACT' },
        { label: 'Northern Territory', value: 'NT' }
    ],
    'New Zealand': [
        { label: 'Northland', value: 'NL' },
        { label: 'Auckland', value: 'AUK' },
        { label: 'Waikato', value: 'WKO' },
        { label: 'Bay of Plenty', value: 'BOP' },
        { label: 'Gisborne', value: 'GIS' },
        { label: "Hawke's Bay", value: 'HKB' },
        { label: 'Taranaki', value: 'TKI' },
        { label: 'Manawatū-Whanganui', value: 'MWT' },
        { label: 'Wellington', value: 'WGN' },
        { label: 'Tasman', value: 'TAS' },
        { label: 'Nelson', value: 'NSN' },
        { label: 'Marlborough', value: 'MBH' },
        { label: 'West Coast', value: 'WTC' },
        { label: 'Canterbury', value: 'CAN' },
        { label: 'Otago', value: 'OTA' },
        { label: 'Southland', value: 'STL' }
    ],
    US: [
        { label: 'Alabama', value: 'AL' },
        { label: 'Alaska', value: 'AK' },
        { label: 'Arizona', value: 'AZ' },
        { label: 'Arkansas', value: 'AR' },
        { label: 'California', value: 'CA' },
        { label: 'Colorado', value: 'CO' },
        { label: 'Connecticut', value: 'CT' },
        { label: 'Delaware', value: 'DE' },
        { label: 'Florida', value: 'FL' },
        { label: 'Georgia', value: 'GA' },
        { label: 'Hawaii', value: 'HI' },
        { label: 'Idaho', value: 'ID' },
        { label: 'Illinois', value: 'IL' },
        { label: 'Indiana', value: 'IN' },
        { label: 'Iowa', value: 'IA' },
        { label: 'Kansas', value: 'KS' },
        { label: 'Kentucky', value: 'KY' },
        { label: 'Louisiana', value: 'LA' },
        { label: 'Maine', value: 'ME' },
        { label: 'Maryland', value: 'MD' },
        { label: 'Massachusetts', value: 'MA' },
        { label: 'Michigan', value: 'MI' },
        { label: 'Minnesota', value: 'MN' },
        { label: 'Mississippi', value: 'MS' },
        { label: 'Missouri', value: 'MO' },
        { label: 'Montana', value: 'MT' },
        { label: 'Nebraska', value: 'NE' },
        { label: 'Nevada', value: 'NV' },
        { label: 'New Hampshire', value: 'NH' },
        { label: 'New Jersey', value: 'NJ' },
        { label: 'New Mexico', value: 'NM' },
        { label: 'New York', value: 'NY' },
        { label: 'North Carolina', value: 'NC' },
        { label: 'North Dakota', value: 'ND' },
        { label: 'Ohio', value: 'OH' },
        { label: 'Oklahoma', value: 'OK' },
        { label: 'Oregon', value: 'OR' },
        { label: 'Pennsylvania', value: 'PA' },
        { label: 'Rhode Island', value: 'RI' },
        { label: 'South Carolina', value: 'SC' },
        { label: 'South Dakota', value: 'SD' },
        { label: 'Tennessee', value: 'TN' },
        { label: 'Texas', value: 'TX' },
        { label: 'Utah', value: 'UT' },
        { label: 'Vermont', value: 'VT' },
        { label: 'Virginia', value: 'VA' },
        { label: 'Washington', value: 'WA' },
        { label: 'West Virginia', value: 'WV' },
        { label: 'Wisconsin', value: 'WI' },
        { label: 'Wyoming', value: 'WY' }
    ],
    Other: []
};

export const getCountry = (country?: number | string | null): CountryCode => {
    if (country === undefined || country === null || country === '') return 'US';

    if (typeof country === 'string') {
        const nameToCountry: Record<string, CountryCode> = {
            other: 'Other',
            usa: 'US',
            canada: 'Canada',
            australia: 'Australia',
            newzealand: 'New Zealand'
        };
        return nameToCountry[country.toLowerCase()] ?? 'US';
    }

    const idToCountry: Record<number, CountryCode> = {
        1: 'US',
        2: 'Canada',
        3: 'Australia',
        4: 'New Zealand',
        0: 'Other'
    };

    return idToCountry[country] ?? 'US';
};
